import React from "react";
import { FormGroup } from "react-bootstrap";
import { Field } from "react-final-form";
import { formatDate } from "../../../../../web/Utils/utils";
import FeatherIconWrapper from "../../Icons/FeatherIconWrapper";
import DayPickerInput from "react-day-picker/DayPickerInput";
import 'react-day-picker/lib/style.css';

import { Black } from "../../../Constants/ColorChart";
import CalendarIcon from "../../Icons/Calendar/Calendar";
import './DateField.css'
import { TWO_WEEKS } from "../../../Constants/AppData";

const DateError = ( { name } ) => {
    return <Field name={ name } subscription={ { error: true } }>
        { ( { meta: { error } } ) =>
            error ? <div className="errorMessage"><span>{ error }</span></div> : null
        }
    </Field>
}

export const DateField = ( props ) => {
    const {
        fieldId,
        fieldLabel,
        hint,
        validator
    } = props

    return <Field name={ fieldLabel } validate={ validator }>
        { ( { input, meta } ) => {
            const inputValue = input.value !== "" ? formatDate( input.value.toISOString().substr( 0, 10 ) ) : ""
            return <FormGroup
                className={ ((meta.error || input.value === "") ? "has-error " : " ") + (!meta.error && (meta.modified || meta.touched) ? "is-success " : " ") }>
                <div className="text">
                    <label htmlFor={ fieldId }>{ fieldLabel }
                        { (meta.error || input.value) &&
                        <DateError name={ fieldLabel }>{ meta.error }</DateError> }
                    </label>
                    { hint && <p>
                        { hint }
                    </p> }
                    <div
                        className={ ((input.value) !== '' ? 'selected' : 'clear') + " filter-box filter-date-box questionnaire" }>
                        <input
                            className="form-control"
                            defaultValue={ input.value ? inputValue : "" }
                        />
                        <DayPickerInput
                            { ...input }
                            className={ " filter-field filter-date-field" }
                            onDayChange={ input.onChange }
                            value={ input.value }
                            inputProps={ { name: fieldLabel } }
                            dayPickerProps={ {
                                showOutsideDays: true,
                                disabledDays: [ { before: new Date( Date.parse( new Date() ) + TWO_WEEKS ) }, { daysOfWeek: [ 0, 6 ] } ]
                            } }
                        />
                        <FeatherIconWrapper
                            color={ Black }
                            fillColor={ "none" }
                            iconStyle={ { width: "16px", verticalAlign: "middle", strokeWidth: "2px" } }
                            Icon={ CalendarIcon }
                        />
                    </div>
                </div>
            </FormGroup>
        } }
    </Field>;
}